(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!window.snusventaProductPageLoaded) {
    window.snusventaProductPageLoaded = true;

    const formatSnusVentaMoney = function (cents, currency, locale) {
      const amount = Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat(locale || undefined, {
          style: 'currency',
          currency: currency || 'EUR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return '€' + amount.toFixed(2);
      }
    };

    const updateSnusVentaProductPage = function (section, selectedButton) {
      if (!section || !selectedButton) return;

      const form = section.querySelector('[data-sv-product-form]');
      const quantityInput = section.querySelector('[data-sv-quantity]');
      const totalPrice = section.querySelector('[data-sv-total-price]');
      const unitPrice = section.querySelector('[data-sv-unit-price]');
      const topPrice = section.querySelector('[data-sv-top-price]');
      const addButton = section.querySelector('[data-sv-add-button]');

      if (!form || !quantityInput) return;

      const basePrice = Number(form.dataset.basePrice || 0);
      const currency = form.dataset.currency || 'EUR';
      const locale = form.dataset.locale || undefined;
      const quantity = Number(selectedButton.dataset.packSize || 1);
      const discount = Number(selectedButton.dataset.discount || 0);

      const total = Math.round(basePrice * quantity * (100 - discount) / 100);
      const unit = Math.round(total / quantity);

      quantityInput.value = quantity;

      if (totalPrice) {
        totalPrice.textContent = formatSnusVentaMoney(total, currency, locale);
      }

      if (unitPrice) {
        unitPrice.textContent = formatSnusVentaMoney(unit, currency, locale) + (document.documentElement.lang.slice(0,2)==='es'?'/lata':'/can');
      }

      if (topPrice) {
        topPrice.textContent = formatSnusVentaMoney(basePrice, currency, locale);
      }

      if (addButton && !addButton.disabled) {
        addButton.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Añadir ':'Add ') + quantity + (document.documentElement.lang.slice(0,2)==='es'?' latas al carrito':' Pack to cart');
      }
    };

    document.addEventListener('click', function (event) {
      const packButton = event.target.closest('.sv-pack-option[data-pack-size]');
      if (!packButton) return;

      const section = packButton.closest('[data-sv-product-section]');
      if (!section) return;

      section.querySelectorAll('.sv-pack-option[data-pack-size]').forEach(function (button) {
        const isActive = button === packButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      updateSnusVentaProductPage(section, packButton);
    });

    document.addEventListener('submit', function (event) {
      const form = event.target.closest('[data-sv-product-form]');
      if (!form) return;

      event.preventDefault();

      const section = form.closest('[data-sv-product-section]');
      const variantInput = form.querySelector('[data-sv-variant-id]');
      const quantityInput = form.querySelector('[data-sv-quantity]');
      const addButton = form.querySelector('[data-sv-add-button]');
      const message = form.querySelector('[data-sv-product-message]');

      if (!section || !variantInput || !quantityInput || !addButton) return;

      const variantId = Number(variantInput.value);
      const quantity = Number(quantityInput.value || 1);

      if (!variantId || !quantity || addButton.disabled) return;

      addButton.disabled = true;
      addButton.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Añadiendo...':'Adding...');
      addButton.classList.remove('is-added');

      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function (result) {
          addButton.textContent = 'Added';
          addButton.classList.add('is-added');

          if (message) {
            message.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Añadido al carrito':'Added to cart');
            message.classList.add('is-visible');
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                source: 'snusventa-product-page',
                result: result
              }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                source: 'snusventa-product-page',
                result: result
              }
            })
          );

          setTimeout(function () {
            const activeButton = section.querySelector('.sv-pack-option.is-active');
            addButton.disabled = false;
            addButton.classList.remove('is-added');

            if (activeButton) {
              updateSnusVentaProductPage(section, activeButton);
            } else {
              addButton.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Añadir al carrito':'Add to cart');
            }

            if (message) {
              message.classList.remove('is-visible');
            }
          }, 1300);
        })
        .catch(function (error) {
          addButton.disabled = false;
          addButton.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Inténtalo de nuevo':'Try again');

          if (message) {
            message.textContent = error.description || (document.documentElement.lang.slice(0,2)==='es'?'No se pudo añadir':'Could not add');
            message.classList.add('is-visible');
          }

          setTimeout(function () {
            const activeButton = section.querySelector('.sv-pack-option.is-active');

            if (activeButton) {
              updateSnusVentaProductPage(section, activeButton);
            } else {
              addButton.textContent = (document.documentElement.lang.slice(0,2)==='es'?'Añadir al carrito':'Add to cart');
            }

            if (message) {
              message.classList.remove('is-visible');
            }
          }, 1800);
        });
    });

    const initSnusVentaProductPages = function () {
      document.querySelectorAll('[data-sv-product-section]').forEach(function (section) {
        const activeButton = section.querySelector('.sv-pack-option.is-active');
        updateSnusVentaProductPage(section, activeButton);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSnusVentaProductPages);
    } else {
      initSnusVentaProductPages();
    }

    document.addEventListener('shopify:section:load', initSnusVentaProductPages);
  }

  } catch(e) { console.error(e); }
})();
})();
